import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Table } from 'app/components';
import { getEventList } from './api';
import { COLUMN_CONFIG, ACTION_ITEMS } from './constants';

const AdminFinishedEventsList = () => {
  const { eventList, filters, totalPages } = useSelector((state) => state.adminFinishedEventsList);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    getEventList({ ...filters });
  }, [filters]);

  const onChangeTableData = (key, value) => {
    const filterKey = key === 'search' ? 'searchText' : key;

    if (filters?.[filterKey] !== value) {
      dispatch({
        type: 'ADMIN_PRIMARY_FINISHED_EVENT_LIST:FILTERS:SET',
        data: {
          ...filters,
          [filterKey]: value,
          ...(filterKey !== 'page_no' && ({
            page_no: 1,
          })),
        },
      });
    }
  };

  const onClickActionItem = (actionItem, row) => {
    if (actionItem.action === 'edit') {
      navigate(`../admin/primary/event/${row?.id}`)
    }
  };

  return (
    <div className="flex flex-col gap-4 p-5 admin-events-list">
      <Table
        totalPages={totalPages}
        showSearch={true}
        columns={COLUMN_CONFIG}
        rows={eventList}
        selectedPage={filters?.page_no}
        searchText={filters?.searchText}
        onChange={onChangeTableData}
        actionItems={ACTION_ITEMS}
        onClickActionItem={onClickActionItem}
      />
    </div>
  );
};

export default AdminFinishedEventsList;
